import React from 'react';
import { Formik } from 'formik';
import { useIntl } from 'react-intl';

import Wrapper from 'container/layouts/Wrapper';
import PageTitle from 'components/PageTitle';

import TelcosImg from 'assets/img/telcos-2.png';

// COMPONENT IMPORTS
import Input from 'components/Form/Input';
// import PhoneInput from 'components/Form/Phone';
import Select from 'components/Form/Select';
import Checkbox from 'components/Form/Checkbox';
import FormButton from 'components/Form/Button';

const ShopTollbooth = (props) => {
  document.title = 'REACHAFRIKA | SHOP - TOLLBOOTH';
  const intl = useIntl();

  return (
    <Wrapper intl={intl} className="h-screen flex overflow-hidden bg-gray-100" {...props}>
      <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none" tabIndex="0">
        <PageTitle intl={intl} title="Tollbooth" />
        <div className="text-sm pt-2 pb-6 mx-4 md:py-10 xl:mx-24">
          <div className="flex flex-wrap flex-col-reverse xl:flex-row xl:flex-no-wrap mt-1 ml-2">
            <div className="bg-white w-full xl:w-4/6 xl:mr-2 rounded-md">
              <div className="flex border-b border-gray-300 py-5">
                <h4 className="font-medium px-5 text-xl">Buy Airtime</h4>
              </div>
              <div className="flex px-5 md:px-10 py-5">
                <div className="hidden w-2/12 mr-5 md:block">
                  <img className="w-full" src={TelcosImg} alt="Telcos" />
                </div>
                <div className="w-full xl:w-10/12 xl:ml-5">
                  <Formik
                    initialValues={{
                      provider: '',
                      account_number: '',
                      phone_number: ''
                    }}
                    // validationSchema={SignInSchema}
                    onSubmit={(values) => {
                      // dispatch(loginRequest({ data: values, history: props.history }));
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      dirty,
                      isSubmitting,
                      isValid,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      setFieldTouched,
                      handleSubmit
                    }) => (
                      <form className="block" onSubmit={handleSubmit}>
                        <div className="flex flex-wrap">
                          <div className="flex flex-col w-full">
                            <div className="mb-6">
                              <Select
                                name="provider"
                                placeholder="Select Provider"
                                value={values.provider}
                                error={errors.provider}
                                touched={touched.provider}
                                options={['LLC']}
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                                useFloatingLable={false}
                              />
                            </div>
                          </div>
                          <div className="flex flex-wrap xl:flex-no-wrap w-full">
                            <div className="w-full xl:w-1/2 xl:mr-2">
                              <Input
                                type="text"
                                name="account_number"
                                placeholder="Provider Account Number"
                                inputValue={values.account_number}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.account_number}
                                touched={touched.account_number}
                                useFloatingLable={false}
                              />
                            </div>
                            <div className="w-full xl:w-1/2 xl:ml-2">
                              <Input
                                type="number"
                                name="amount"
                                min="1"
                                placeholder="Amount (₦)"
                                inputValue={values.amount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.amount}
                                touched={touched.amount}
                                useFloatingLable={false}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col xl:flex-row w-full xl:w-1/2 xl:ml-2">
                          <Checkbox
                            id="use_reward"
                            title="Use Reward"
                            action={() => {}}
                            className="mb-6 flex items-center"
                          />
                        </div>
                        <div className="flex justify-center mt-2 xl:px-4 xl:w-1/2">
                          <FormButton
                            title="Proceed"
                            color="bg-ra-dark"
                            disabled={!(dirty && isValid) || isSubmitting}
                            loading={isSubmitting}
                          />
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
            <div className="bg-white w-full xl:w-2/6 mb-5 xl:mb-0 pb-5 xl:ml-2">
              <div className="border-gray-300 rounded-md">
                <div className="flex border-b border-gray-300 py-5">
                  <h4 className="font-medium px-5 text-xl">Invoice</h4>
                </div>
                <div className="px-5 mt-2">
                  <div className="flex justify-between border-b border-gray-300 py-4 px-2 mt-2">
                    <span>Bill</span>
                    <span>0</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-300 py-4 px-2 mt-2">
                    <span>Convenience Fee</span>
                    <span>0</span>
                  </div>
                  <div className="flex justify-between bg-gray-100 py-4 px-2 mt-2 font-semibold rounded-md">
                    <span>Net Payable</span>
                    <span>0</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Wrapper>
  );
};

export default ShopTollbooth;
